import { render, staticRenderFns } from "./logList.vue?vue&type=template&id=2053b624&"
import script from "./logList.vue?vue&type=script&lang=js&"
export * from "./logList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\svn\\家用后台\\branches\\20240430-1.5.0\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2053b624')) {
      api.createRecord('2053b624', component.options)
    } else {
      api.reload('2053b624', component.options)
    }
    module.hot.accept("./logList.vue?vue&type=template&id=2053b624&", function () {
      api.rerender('2053b624', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/xunfei/logs/logList.vue"
export default component.exports